module.exports = __webpack_public_path__ + "static/media/chat-app.51092d68.png";